import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Safaris from "@/pages/Safaris";
import SafariDetail from "@/pages/SafariDetail";
import Experiences from "@/pages/Experiences";
import Policies from "@/pages/Policies";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import { HelmetProvider } from "react-helmet-async";
import { SeoDefaults } from "@/components/Seo";
import Checkout from "@/pages/Checkout";
import BookingSuccess from "@/pages/BookingSuccess";
import BookingLookup from "@/pages/BookingLookup";
import BookingEngine from "@/pages/BookingEngine";
import About from "@/pages/About";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Hotels from "@/pages/Hotels";
import HotelDetail from "@/pages/HotelDetail";
import Packages from "@/pages/Packages";
import PackageDetail from "@/pages/PackageDetail";
import { AuthProvider } from "@/context/AuthContext";
import { TripProvider } from "@/context/TripContext";
import WhatsAppButton from "@/components/WhatsAppButton";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function RazorpayLoader() {
  useEffect(() => {
    if (document.getElementById("rzp-sdk")) return;
    const s = document.createElement("script");
    s.id = "rzp-sdk";
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    document.body.appendChild(s);
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <AuthProvider>
        <TripProvider>
        <BrowserRouter>
          <RazorpayLoader/>
          <ScrollToTop/>
          <Header/>
          <main className="min-h-[60vh]">
            <SeoDefaults/>
            <Routes>
              <Route path="/" element={<Home/>}/>
              <Route path="/safaris" element={<Safaris/>}/>
              <Route path="/safaris/:slug" element={<SafariDetail/>}/>
              <Route path="/experiences" element={<Experiences/>}/>
              <Route path="/policies" element={<Policies/>}/>
              <Route path="/blog" element={<Blog/>}/>
              <Route path="/blog/:slug" element={<BlogPost/>}/>
              <Route path="/policies/:section" element={<Policies/>}/>
              <Route path="/book" element={<BookingEngine/>}/>
              <Route path="/stays" element={<Hotels/>}/>
              <Route path="/stays/:slug" element={<HotelDetail/>}/>
              <Route path="/packages" element={<Packages/>}/>
              <Route path="/packages/:slug" element={<PackageDetail/>}/>
              <Route path="/checkout" element={<Checkout/>}/>
              <Route path="/booking-success" element={<BookingSuccess/>}/>
              <Route path="/lookup" element={<BookingLookup/>}/>
              <Route path="/about" element={<About/>}/>
              <Route path="/admin/login" element={<AdminLogin/>}/>
              <Route path="/admin" element={<AdminDashboard/>}/>
            </Routes>
          </main>
          <Footer/>
          <WhatsAppButton/>
          <Toaster position="top-right" richColors/>
        </BrowserRouter>
        </TripProvider>
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
